import {AfterViewInit, Component, ElementRef, EventEmitter, OnInit, ViewChild} from '@angular/core';
import {Helper} from '../../../../helpers/helper.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {LanguageService} from '../../../../translation/Services/language.service';
import {DealerDashboardService} from '../../../Services/dealer-dashboard.service';
import {DealerBlock} from '../../../Models/DealerBlock';
import {Language} from '../../../Models/Languge';
import * as Quill from 'quill';
import {BehaviorSubject} from 'rxjs';
import {FileItem, FileUploader, ParsedResponseHeaders} from 'ng2-file-upload';
import {environment} from '../../../../../environments/environment';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {take} from 'rxjs/operators';
import {DealerProfileService} from '../../../Services/dealer-profile.service';
import {SupplierService} from '../../../Services/supplier.service';


const baseUri = environment.apiUrl;
const URL = baseUri + '/backoffice/file_manager?bupload=dealerBlock.content&generate-default=false';

/**
 * Quill JS Custom elements
 */
const Link = Quill.import('formats/link');
const Image = Quill.import('formats/image');
const BlockEmbed = Quill.import('blots/block/embed');

class BtnLinkBlot extends Link {
  static blotName: string = 'btn-link';
  static tagName: string = 'a';
  static className: string = 'btn';

  static create(url) {
    let node = super.create();
    node.setAttribute('href', url);
    node.setAttribute('class', 'btn btn-primary ripple light');
    return node;
  }

  static formats(node) {
    return node.getAttribute('href');
  }
}

class ImageBlot extends Image {
  static create(url) {
    let node = super.create(url);
    node.setAttribute('class', 'img-fluid');
    return node;
  }
}

class VideoBlot extends BlockEmbed {
  static blotName = 'video';
  static tagName = 'div';
  static className = 'embed-responsive';

  static create(value) {

    const node = super.create();
    node.classList.add('embed-responsive-16by9');

    const child = document.createElement('iframe');
    child.setAttribute('frameborder', '0');
    child.setAttribute('allowfullscreen', 'true');
    child.setAttribute('src', this.sanitize(value));
    child.classList.add('embed-responsive-item');

    node.appendChild(child);

    return node;
  }

  static sanitize(url) {
    return Link.sanitize(url);
  }

  static value(domNode) {
    const iframe = domNode.querySelector('iframe');
    return iframe.getAttribute('src');
  }
}

Quill.register(BtnLinkBlot, true);
Quill.register(ImageBlot, true);
Quill.register(VideoBlot, true);

@Component({
  selector: 'app-manage-block',
  templateUrl: './manage-block.component.html',
  styleUrls: ['./manage-block.component.scss']
})
export class ManageBlockComponent implements OnInit, AfterViewInit {

  @ViewChild('inputModal', {static: false}) inputModal;
  @ViewChild('uploadEl', {static: false}) uploadElRef: ElementRef;
  @ViewChild('imageElement', {static: false}) imageElement: ElementRef;

  public block: DealerBlock = new DealerBlock();
  public languages;
  public profiles;
  public blockId: number;
  public isEdit = false;
  public classicBox;
  public modules = {};
  public enableSave = true;
  public status = [
    {label: this.translate.instant('global.active'), value: true},
    {label: this.translate.instant('global.inactive'), value: false},
  ];
  public quill;
  public input_address: string;
  public inputAccepted = new EventEmitter<string>();
  public modalHandler = new BehaviorSubject<string>(null);
  public user_statuses = [
    {label: this.translate.instant('global.active'), value: 'active'},
    {label: this.translate.instant('global.on_hold'), value: 'on_hold'},
  ];

  /**
   * Upload file variables
   */
  public fileUrl = null;

  public uploader: FileUploader = new FileUploader({
    itemAlias: 'content',
    url: URL,
    authToken: this.auth.getBearerHeader(),
  });
  private target: any;
  public addFileItem = false;
  public isUploading = false;
  public isNotAdd = false;
  public statuses: any[];
  public suppliers: any[];

  /**
   *
   * @param helper
   * @param route
   * @param router
   * @param translate
   * @param dealerDashboardService
   * @param languageService
   * @param dealerProfileService
   * @param elem
   * @param auth
   * @param supplierService
   */
  constructor(
    private helper: Helper,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private dealerDashboardService: DealerDashboardService,
    private languageService: LanguageService,
    public dealerProfileService: DealerProfileService,
    private elem: ElementRef,
    private auth: AuthenticationService,
    private supplierService: SupplierService
  ) {
  }

  ngOnInit() {
    this.block.status = true; // Set status default value
    this.block.userStatus = 'active';

    this.uploader.onAfterAddingFile = (item => {
      if (this.target) {
        this.target.value = '';
      }
      item.withCredentials = false;
    });


    this.modules = {
      toolbar: {
        container: [
          ['bold', 'italic', 'underline', 'strike'],                  // toggled buttons
          ['blockquote', 'code-block'],

          [{'header': 1}, {'header': 2}],                             // custom button values
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{'script': 'sub'}, {'script': 'super'}],                   // superscript/subscript
          [{'indent': '-1'}, {'indent': '+1'}],                       // outdent/indent
          [{'direction': 'rtl'}],                                     // text direction

          [{'size': ['small', false, 'large', 'huge']}],              // custom dropdown
          [{'header': [1, 2, 3, 4, 5, 6, false]}],

          [{'color': []}, {'background': []}],                        // dropdown with defaults from theme
          [{'font': []}],
          [{'align': []}],

          ['clean'],                                                  // remove formatting button

          ['link', 'btn-link', 'image', 'video', 'file', 'delivery'],    // link and image, video

        ],
        handlers: {
          'btn-link': (value) => {
            if (value) {
              let range = this.quill.getSelection();
              if (range == null || range.length == 0) return;
              let preview = this.quill.getText(range);
              if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
                preview = 'mailto:' + preview;
              }
              this.modalHandler.next('link');
              this.input_address = preview;
              this.inputAccepted.pipe(take(1)).subscribe((inputAccepted) => {
                if ('link' === inputAccepted) {
                  this.quill.format('btn-link', this.input_address);
                }
              });
            } else {
              this.quill.format('btn-link', false);
            }
          },
          'image': (value) => {
            if (value) {
              let range = this.quill.getSelection(true);
              this.modalHandler.next('image');
              this.inputAccepted.pipe(take(1)).subscribe((inputAccepted) => {
                if ('image' === inputAccepted) {
                  this.quill.insertEmbed(range.index, 'image', this.input_address, 'user');
                  this.quill.setSelection(range.index + 1, 'silent');
                }
              });
            } else {
              this.quill.format('image', false);
            }
          },
          'video': (value) => {
            if (value) {
              let range = this.quill.getSelection(true);
              this.modalHandler.next('video');
              this.inputAccepted.pipe(take(1)).subscribe((inputAccepted) => {
                if ('video' === inputAccepted) {
                  const youtubeUrlRegex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
                  const match = this.input_address.match(youtubeUrlRegex);
                  if (youtubeUrlRegex.test(this.input_address)) {
                    this.quill.insertEmbed(range.index, 'video', `https://www.youtube.com/embed/${match[2]}?rel=0`, 'user');
                  } else {
                    this.quill.insertEmbed(range.index, 'video', this.input_address, 'user');
                  }
                  this.quill.formatText(range.index + 1, 1, {height: '170', width: '400'});
                  this.quill.setSelection(range.index + 1, 'silent');
                }
              });
            } else {
              this.quill.format('video', false);
            }
          },
          'file': (value) => {
            if (value) {
              let range = this.quill.getSelection();
              if (range == null || range.length == 0) return;
              this.modalHandler.next('file');
              this.inputAccepted.pipe(take(1)).subscribe((inputAccepted) => {
                if ('file' === inputAccepted) {
                  this.quill.format('link', this.input_address);
                }
              });
            } else {
              this.quill.format('link', false);
            }
          },
          'delivery': (value) => {
            if (value) {
              const deliveryMenu = this.elem.nativeElement.querySelector('.ql-delivery');
              if (deliveryMenu.classList.contains('ql-expanded')) {
                deliveryMenu.classList.remove('ql-picker');
                deliveryMenu.classList.remove('ql-expanded');
              } else {
                deliveryMenu.classList.add('ql-picker');
                deliveryMenu.classList.add('ql-expanded');
              }
            }
          }
        }
      },
    };

    this.languageService.list().subscribe(response => {
      this.languages = response.languages.map((value) => ({
          label: value.name,
          value: value.id
        }));
    });

    this.dealerProfileService.getProfiles().subscribe(response => {
      this.profiles = response.data.map((value) => ({
          label: value.name,
          value: value.id
        }));
    });

    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.blockId = params['id'];
        this.isEdit = true;
        this.dealerDashboardService.getBlockItem(this.blockId).subscribe(resp => {
          this.block = resp;
          this.block.language = (this.block.language as Language).id;
          const lastValueProfiles = [];
          this.block.profiles.forEach(profile => {
            lastValueProfiles.push(profile.id);
          });
          this.block.profiles = lastValueProfiles;
          if (this.block.locked) {
            const lastValueStatuses = [];
            this.block.statuses.forEach(status => {
              lastValueStatuses.push(status.id);
            });
            this.block.statuses = lastValueStatuses;
            const lastValueSuppliers = [];
            this.block.suppliers.forEach(status => {
              lastValueSuppliers.push(status.id);
            });
            this.block.suppliers = lastValueSuppliers;
            this.dealerDashboardService.getOrderStatuses().subscribe(response => {
              this.statuses = response.statuses.map((value) => ({
                  label: this.translate.instant(value.translationKey),
                  value: value.id
                }));
            });
          }
        });
      }
    });

    this.modalHandler.subscribe((type) => {
      this.input_address = null;
      this.removeImage();
      if (null !== type) {
        this.inputModal.show();
      }
    });
  }


  enableButton(event) {

    this.enableSave = event;
  }


  submitItem(next: boolean) {
    if (next) {
      const block = Object.assign({}, this.block);
      delete block.id;
      delete block.locked;
      this.dealerDashboardService.manageBlock(block, this.isEdit, this.blockId).subscribe((resp) => {
        this.router.navigateByUrl('/back-office/dealer-dashboard/overview');
      });
    } else {
      this.router.navigateByUrl('/back-office/dealer-dashboard/overview');
    }

  }


  onEditorCreated(quill) {
    this.quill = quill;
  }

  ngAfterViewInit() {
    // Update your dropdown with labels
    const btnLink = this.elem.nativeElement.querySelector('.ql-btn-link');
    if (btnLink) {
      btnLink.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 393 393"><defs/><path d="M130 196c0 9 7 15 15 15h102a15 15 0 000-30H145c-8 0-15 7-15 15z"/><path d="M177 237h-51c-11 0-19-9-19-20v-41c0-11 8-20 19-20h51a15 15 0 000-30h-51c-27 0-49 22-49 50v41c0 27 22 50 49 50h51a15 15 0 000-30zM266 126h-50a15 15 0 000 30h50c11 0 20 9 20 20v41c0 11-9 20-20 20h-50a15 15 0 000 30h50c28 0 50-23 50-50v-41c0-28-22-50-50-50z"/><path d="M311 1H82C37 1 0 38 0 83v227c0 45 37 82 82 82h229c45 0 82-37 82-82V83c0-45-37-82-82-82zm52 309c0 28-24 52-52 52H82c-29 0-52-24-52-52V83c0-29 23-52 52-52h229c28 0 52 23 52 52v227z"/></svg>' + btnLink.innerHTML;
    }

    const file = this.elem.nativeElement.querySelector('.ql-file');
    if (file) {
      file.innerHTML = '<i class="fa fa-file"></i>' + file.innerHTML;
    }

    this.supplierService.getSupplier().subscribe(response => {
      this.suppliers = response.data.map((value) => ({
          label: value.companyName,
          value: value.id
        }));
      let deliveryButtons = '';
      this.suppliers.forEach(supplier => {
        deliveryButtons += '<span tabindex="0" role="button" class="ql-picker-item text-start text-body" data-id="' + supplier.value + '">' +
          supplier.label + ' ' + this.translate.instant('doctrine.order.delivery_week') +
          '</span>';
      });

      const delivery = this.elem.nativeElement.querySelector('.ql-delivery');
      if (delivery) {
        delivery.innerHTML = '<div class="d-flex" tabindex="0" role="button" aria-expanded="true" aria-controls="ql-picker-options-1">' +
          '<i class="fa fa-truck me-1"></i><i class="fa fa-caret-down"></i></div>' +
        '<span class="ql-picker-options" aria-hidden="false" tabindex="-1" id="ql-picker-options-0">' +
        deliveryButtons + '</span>' + delivery.innerHTML;
      }

      const deliveryWeekButtons = this.elem.nativeElement.querySelectorAll('.ql-delivery .ql-picker-item');
      deliveryWeekButtons.forEach(deliveryWeekButton => {
        deliveryWeekButton.addEventListener('click', (item) => {
          const range = this.quill.getSelection(true);
          this.quill.insertText(range.index, '{{deliveryWeek:' + deliveryWeekButton.getAttribute('data-id') + '}}');
        });
      });

    });

  }

  cancelInput() {
    this.modalHandler.next(null);
    this.inputModal.hide();
  }

  acceptInput() {
    this.inputAccepted.emit(this.modalHandler.value);
    this.inputModal.hide();
  }


  /**
   * Upload file functionality
   *
   */

  uploadFile(cb) {
    this.addFileItem = true;
    this.isUploading = true;
    this.uploader.setOptions({
      ...this.uploader.options,
      url: URL + (this.modalHandler.value === 'image' ? '&quality=75' : '')
    });
    this.uploader.uploadAll();
    this.uploader.onErrorItem = (item: FileItem, response, status: number, headers: ParsedResponseHeaders) => {
      this.removeImage();
      const res = JSON.parse(response);
      this.helper.popMessageDialog(res.title, res.errors);
    };
    this.uploader.onSuccessItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      if (response) {
        this.addFileItem = false;
        this.isUploading = false;
        this.isNotAdd = false;
        const res = JSON.parse(response);
        this.fileUrl = environment.absolutePath + '/' + res.fullPath;
        cb();
      }
    };
  }

  changeImage(event) {
    this.fileUrl = null;
    this.isUploading = false;
    this.uploader.clearQueue();
    const element: HTMLElement = document.getElementById('uploaderFile') as HTMLElement;
    element.click();
  }

  fileChange($event: Event) {
    const reader = new FileReader();
    reader.onloadend = (e) => {
      this.fileUrl = reader.result;
    };
    if (this.uploader.queue[0]._file) {
      return reader.readAsDataURL(this.uploader.queue[0]._file);
    }
  }

  removeImage() {
    this.isUploading = false;
    this.fileUrl = null;
    this.uploader.clearQueue();
    if (this.uploadElRef) {
      this.uploadElRef.nativeElement.value = '';
    }
    this.input_address = null;
  }

  uploadImage() {
    this.uploadFile(() => {
      this.input_address = JSON.parse(JSON.stringify(this.fileUrl));
    });
  }
}
